import { NavLink } from "react-router-dom";

import { List, ListItem, ListItemText, makeStyles } from "@material-ui/core";

import palette from "src/styles/palette";

import BackToSubaccountListItem from "./BackToSubaccountListItem";
import { useAdminSubaccountMemberships } from "./LoggedInAdminProvider";

const useStyles = makeStyles(() => ({
  sidebar: {
    minHeight: "calc(100vh - 80px)",
    width: "240px",
    paddingTop: 20,
    background: palette.lightGray
  },
  sidebarItem: {
    fontSize: 16, // TODO: use Typography
    paddingLeft: 24
  }
}));

export default function UserSidebar({
  baseUrl
}: {
  baseUrl: string;
}): JSX.Element {
  const memberships = useAdminSubaccountMemberships()!;

  const items = [
    {
      label: "My Profile",
      path: `${baseUrl}/profile`
    },
    ...(memberships.length > 1
      ? [
          {
            label: "Subaccounts",
            path: `${baseUrl}/subaccounts`
          }
        ]
      : [])
  ];

  const classes = useStyles();
  return (
    <div className={classes.sidebar}>
      <List>
        {items.map(({ label, path }, idx) => (
          <ListItem
            key={idx}
            dense
            button
            className={classes.sidebarItem}
            component={NavLink}
            to={path}
            activeStyle={{ fontWeight: 999 }}
          >
            <ListItemText disableTypography primary={label} />
          </ListItem>
        ))}
        <BackToSubaccountListItem className={classes.sidebarItem} />
      </List>
    </div>
  );
}
